export class VendorSetupDomestic {
    public CompanyName: string;
    public FeinNumber: string;
    public ContactPerson: string;
    public ContactEmail:string;
    public ContactPhone: string;
    public ContactFax: string;
    public ContactAddress1: string;
    public ContactAddress2: string;
    public ContactCity: string;
    public ContactState: string;
    public ContactZip: string;
    public ContactCountry: string;
    public ContactCurrency: string;
    public PaymentTerms: string;
    public ContractNumber: string;
    public IsCustomer:string;
    public BankName:string;
    public AccountNumber:string;
    public ABANumber:string;
    public AccountType:string;
    public PaymentNotificationMethod:string;
    public CompanyNameRemit:string;
    public ContactPersonRemit:string;
    public ContactEmailRemit:string;
    public ContactPhoneRemit: string;
    public ContactFaxRemit: string;
    public ContactAddress1Remit: string;
    public ContactAddress2Remit: string;
    public ContactCityRemit: string;
    public ContactStateRemit: string;
    public ContactZipRemit: string;
    public ContactCountryRemit: string;
    public ContactCurrencyRemit: string;
    public Organizer:string
    public OrganizerDate:string;
    public AcctVendorNumber:string;
    public DateAdded:string;
    public CreatedBy:string;
    public FileName: string;
    public FileBytesBase64: string;
    public VendorNeededIn: string;
  }



// WEBPACK FOOTER //
// ./src/app/models/VendorSetupDomestic.ts